'use strict';

export const GCE_SERVER_GROUP_HIDDEN_METADATA_KEYS = [
  'load-balancer-names',
  'global-load-balancer-names',
  'backend-service-names',
  'load-balancing-policy',
  'select-zones',
  'customUserData',
];
